import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import { OptionsObject, useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  followGoogleSearchQuery,
  getFollowingGoogleSearchQueries,
  unfollowGoogleSearchQuery,
} from "../../../api/specialization/SocialSpecializationAPI";
import { AlertSuccessProp } from "../../../components/SnackbarNoti";
import { errorNoti } from "../../../util/SnackbarMessage";
import timeSince from "../../../util/TimeSince";
import { Link } from "react-router-dom";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import InfoIcon from "@mui/icons-material/Info";

export function GoogleQueryList() {
  const { t } = useTranslation(["common", "social", "keyword"]);
  const [queries, setQueries] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [forceReload, setForceReload] = useState(false);
  const [query, setQuery] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    getFollowingGoogleSearchQueries().then((res) => {
      setQueries(res);
    });
  }, [forceReload]);
  var rows = queries.map((query) => {
    var chip = <Chip label={t("common:" + query["reportStatus"])}></Chip>;
    if (query["reportStatus"] == "UNPROCESSED") {
      chip = (
        <Chip label={t("common:" + query["reportStatus"])} color="error"></Chip>
      );
    }
    if (query["reportStatus"] == "PROCESSING") {
      chip = (
        <Chip label={t("common:" + query["reportStatus"])} color="info"></Chip>
      );
    }
    if (
      query["reportStatus"] == "PROCESSED" ||
      query["reportStatus"] == "COMPLETED"
    ) {
      chip = (
        <Chip
          label={t("common:" + query["reportStatus"])}
          color="success"
        ></Chip>
      );
    }
    if (!query["active"]) {
      chip = <Chip label={t("common:INACTIVE")}></Chip>;
    }
    return (
      <TableRow key={query["id"]}>
        <TableCell
          style={{
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
          sx={{ fontWeight: "500 !important" }}
        >
          <Link to={"/social-network/google/query/" + query["id"]}>
            {query["query"] ? query["query"] : t("common:unknown")}
          </Link>
        </TableCell>
        <TableCell style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          {chip}
        </TableCell>
        <TableCell style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          {query["lastCrawledAt"]
            ? timeSince(query["lastCrawledAt"])
            : t("common:unknown")}
        </TableCell>
        <TableCell
          style={{
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "10px",
            paddingRight: "10px",
          }}
          sx={{ align: "center" }}
        >
          <Box display={"flex"}>
            <Tooltip title={t("common:see_detail")}>
              <Link to={"/social-network/google/query/" + query["id"]}>
                <Button
                  variant="contained"
                  color="info"
                  style={{ marginRight: "10px" }}
                  onClick={() => {}}
                >
                  <InfoIcon />
                </Button>
              </Link>
            </Tooltip>
            <Tooltip title={t("common:unfollow")}>
              <Button
                variant="contained"
                color="error"
                style={{ marginRight: "10px" }}
                onClick={() => {
                  unfollowGoogleSearchQuery(query["id"])
                    .then((res) => {
                      enqueueSnackbar(
                        t("common:update_successfully"),
                        AlertSuccessProp as OptionsObject
                      );
                      window.location.reload();
                    })
                    .catch((err) => {
                      var noti = errorNoti(err);
                      enqueueSnackbar(t("error:" + noti.message), noti.option);
                    });
                }}
              >
                <BookmarkRemoveIcon />
              </Button>
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
    );
  });
  return (
    <div>
      <Box display={"flex"} justifyContent={"flex-begin"} marginBottom={"20px"}>
        <Button
          variant="contained"
          color="success"
          style={{ width: "120px", marginRight: "30px" }}
          onClick={() => {
            setOpenDialog(true);
          }}
        >
          {t("common:follow")}
        </Button>
      </Box>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{t("social:query")}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="name"
            label={t("social:query")}
            placeholder={t("social:query").toString()}
            fullWidth
            required
            variant="standard"
            onChange={(e) => {
              setQuery((e.target as HTMLInputElement).value);
            }}
          ></TextField>
          <DialogActions sx={{ marginTop: "20px" }}>
            <Button
              variant="contained"
              onClick={() => {
                if (query.length > 0) {
                  followGoogleSearchQuery(query).then((res) => {
                    enqueueSnackbar(
                      t("common:update_successfully"),
                      AlertSuccessProp as OptionsObject
                    );
                    setForceReload(!forceReload);
                  });
                  setOpenDialog(false);
                }
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <TableContainer component={Paper}>
        <Table>
          <colgroup>
            <col style={{ width: "60%" }} />
            <col style={{ width: "20%" }} />
            <col style={{ width: "20%" }} />
          </colgroup>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "600 !important" }}>
                {t("social:query")}
              </TableCell>
              <TableCell sx={{ fontWeight: "600 !important" }}>
                {t("social:status")}
              </TableCell>
              <TableCell sx={{ fontWeight: "600 !important" }}>
                {t("social:last_update")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{rows}</TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
